import { ConsumableTypeKey } from "@/services/backend/qpm/types/enums";

export class ConsumableTypeUtil {
  private static descriptions: { [key in ConsumableTypeKey]: string } = {
    [ConsumableTypeKey.Bait]: "Köder",
    [ConsumableTypeKey.Tube]: "Röhre",
    [ConsumableTypeKey.Adhesive]: "Klebefläche",
    [ConsumableTypeKey.LurePheromone]: "Lockstoff (Pheromon)",
    [ConsumableTypeKey.Battery]: "Batterie",
    [ConsumableTypeKey.Sim]: "SIM",
    [ConsumableTypeKey.Cartridge]: "Kartusche",
    [ConsumableTypeKey.FilterMembrane]: "Filtermembran",
    [ConsumableTypeKey.SparePart]: "Ersatzteil",
    [ConsumableTypeKey.Cleaning]: "Reinigung",
    [ConsumableTypeKey.MountingMaterial]: "Montagematerial",
    [ConsumableTypeKey.Calibration]: "Kalibrierung",
  };

  private static abbreviations: { [key in ConsumableTypeKey]: string } = {
    [ConsumableTypeKey.Bait]: "Köder",
    [ConsumableTypeKey.Tube]: "Röhre",
    [ConsumableTypeKey.Adhesive]: "Klebefläche",
    [ConsumableTypeKey.LurePheromone]: "Pheromon",
    [ConsumableTypeKey.Battery]: "Batterie",
    [ConsumableTypeKey.Sim]: "SIM",
    [ConsumableTypeKey.Cartridge]: "Kartusche",
    [ConsumableTypeKey.FilterMembrane]: "Membran",
    [ConsumableTypeKey.SparePart]: "Ersatzteil",
    [ConsumableTypeKey.Cleaning]: "Reinigung",
    [ConsumableTypeKey.MountingMaterial]: "Montage",
    [ConsumableTypeKey.Calibration]: "Kalibrierung",
  };

  static toString(type: ConsumableTypeKey): string {
    return this.abbreviations[type];
  }

  static toLongString(type: ConsumableTypeKey): string {
    return this.descriptions[type] || "Unknown";
  }
}
